import ResultHeader from "../../components/table/ResultHeader";
import ResultRow from "../../components/table/ResultRow";
import ResultHeaderCell from "../../components/table/ResultHeaderCell";
import ResultTable from "../../components/table/ResultTable";
import ResultBody from "../../components/table/ResultBody";
import ResultBodyCell from "../../components/table/ResultBodyCell";
import {useUser} from "../../context/UserContext";
import ResultCellHighlight from "../../components/table/ResultCellHighlight";
import ResultText from "./ResultText";
import EmptyLine from "./EmptyLine";
import HecRasHelper from "../../helpers/HecRasHelper";
import _ from 'lodash';

export default function CalculationTolerances({calculation_tolerances}) {
    const {user} = useUser()

    return (
        <>
            <ResultText>
                {
                    _.isEqual(calculation_tolerances, user.settings.calculation_tolerances) ? 'HEC-RAS calculation tolerances of the plan are identical with the User Default.' : 'HEC-RAS calculation tolerances of the plan are different than the User Default.'
                }
                <EmptyLine />
            </ResultText>
            <ResultTable maxWidth={HecRasHelper.getWidth(70)}>
                <ResultHeader>
                    <ResultRow>
                        <ResultHeaderCell colSpan={3}>HEC-RAS Calculation Tolerances</ResultHeaderCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(40)}}>Calculation</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(15)}}>User Default</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(15)}}>Plan Value</ResultHeaderCell>
                    </ResultRow>
                </ResultHeader>
                <ResultBody>
                    <ResultRow>
                        <ResultHeaderCell style={{textAlign: 'left'}}>Water surface calculation tol. (.0001 - .1 ft)</ResultHeaderCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>{user.settings.calculation_tolerances.stdStepTol}</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>{ResultCellHighlight(user.settings.calculation_tolerances.stdStepTol, calculation_tolerances.stdStepTol)}</ResultBodyCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultHeaderCell style={{textAlign: 'left'}}>Critical depth calculation tol. (.0001 - .1 ft)</ResultHeaderCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>{user.settings.calculation_tolerances.criticalTol}</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>{ResultCellHighlight(user.settings.calculation_tolerances.criticalTol, calculation_tolerances.criticalTol)}</ResultBodyCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultHeaderCell style={{textAlign: 'left'}}>Maximum number of iterations (3 - 40)</ResultHeaderCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>{user.settings.calculation_tolerances.numOfStdStepTrials}</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>{ResultCellHighlight(user.settings.calculation_tolerances.numOfStdStepTrials, calculation_tolerances.numOfStdStepTrials)}</ResultBodyCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultHeaderCell style={{textAlign: 'left'}}>Maximum difference tolerance (.1 - 1.0 ft)</ResultHeaderCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>{user.settings.calculation_tolerances.maxErrorTol}</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>{ResultCellHighlight(user.settings.calculation_tolerances.maxErrorTol, calculation_tolerances.maxErrorTol)}</ResultBodyCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultHeaderCell style={{textAlign: 'left'}}>Flow tolerance factor (.0001 - .05)</ResultHeaderCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>{user.settings.calculation_tolerances.flowTolRatio}</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>{ResultCellHighlight(user.settings.calculation_tolerances.flowTolRatio, calculation_tolerances.flowTolRatio)}</ResultBodyCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultHeaderCell style={{textAlign: 'left'}}>Maximum iteration in Split flow (3 - 100)</ResultHeaderCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>{user.settings.calculation_tolerances.splitFlowNTrial}</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>{ResultCellHighlight(user.settings.calculation_tolerances.splitFlowNTrial, calculation_tolerances.splitFlowNTrial)}</ResultBodyCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultHeaderCell style={{textAlign: 'left'}}>Flow tolerance factor in weir split flow (.0001 - .05)</ResultHeaderCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>{user.settings.calculation_tolerances.splitFlowRatio}</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>{ResultCellHighlight(user.settings.calculation_tolerances.splitFlowRatio, calculation_tolerances.splitFlowRatio)}</ResultBodyCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultHeaderCell style={{textAlign: 'left'}}>Max difference in junction split flow (.001 - .1 ft)</ResultHeaderCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>{user.settings.calculation_tolerances.splitFlowTol}</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>{ResultCellHighlight(user.settings.calculation_tolerances.splitFlowTol, calculation_tolerances.splitFlowTol)}</ResultBodyCell>
                    </ResultRow>
                </ResultBody>
            </ResultTable>
        </>
    )
}